import React from 'react';
import ProtectedRoute from '../components/RouteHelpers/ProtectedRoute/ProtectedRoute';
import useSessionStore from '../stores/useSessionStore';
import AdminManagementLayout from './AdminManagementLayout';

export default function AdminManagementProtected() {
  const user = useSessionStore((s) => s.user);
  return (
    <ProtectedRoute
      isAllowed={!user?.isAllNotAdmin}
      pathRedirect="/projects-new"
    >
      <AdminManagementLayout />
    </ProtectedRoute>
  );
}
